// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import {
  getFirestore,
  setDoc,
  doc,
  getDoc,
  collection,
  query,
  where,
  getDocs,
  addDoc,
  onSnapshot,
  orderBy,
} from "@firebase/firestore";
import {
  createUserWithEmailAndPassword,
  getAuth,
  sendPasswordResetEmail,
  signInWithEmailAndPassword,
  signOut,
} from "firebase/auth";
// import { getToken, getMessaging } from "firebase/messaging";
import {
  ATTENDANCE_COLLECTION,
  SCHOOL,
  COLLEGE,
  SPONSER_COLLECTION,
  SPONSER_INDUSTRY,
  TEACHER,
  USER_COLLECTION,
  VISIT_COLLECTION,
} from "./constants";
import { getStorage, ref, uploadBytes, getDownloadURL } from "firebase/storage";

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyDQqYCzJLHSkPWxLMS62fNbezyocmWipXk",
  authDomain: "open-house-2025-24daf.firebaseapp.com",
  projectId: "open-house-2025-24daf",
  storageBucket: "open-house-2025-24daf.firebasestorage.app",
  messagingSenderId: "444340755870",
  appId: "1:444340755870:web:8ede55df7845136c5bca8f",
  measurementId: "G-T49M3DJ0Z0"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

const auth = getAuth();
const db = getFirestore(app);
const storage = getStorage(app);
// const messaging = getMessaging(app);

// async function requestPermission() {
//   return Notification.requestPermission();
// }
// async function getFCMToken() {
//   return getToken(messaging, {
//     vapidKey:
//       "BCED5uEpRY9gLnjIdGUuNVyHgqMyQCd0HcmKsqy-wEElG-BaT3WcDEHnr0HgPKbUraMheIhlstGWiwsfJy_ama4",
//   });
// }

async function addToken(token) {
  const docRef = doc(db, "Admin", `tokens`);
  const docSnap = await getDoc(docRef);

  if (docSnap.exists()) {
    var list = docSnap.data().token;
    let setData = new Set(list);
    setData.add(token);
    setDoc(docRef, { token: Array.from(setData) });
  } else {
    // docSnap.data() will be undefined in this case
    console.log("No such document!");
  }
  // setDoc(doc(db, "Admin", `tokens`), { token: [token] }, { merge: true });
}

async function addData(data) {
  data.created_at = `${new Date()}`;
  await setDoc(doc(db, USER_COLLECTION, data.email), data);
}

// Function to add sponsor data with unique sponsor_name check
async function addSponserData(data) {
  try {
    // Step 1: Check if sponsor_name already exists in Firestore
    const sponsorQuery = query(
      collection(db, SPONSER_COLLECTION),
      where("sponsor_name", "==", data.sponsor_name)
    );

    const querySnapshot = await getDocs(sponsorQuery);

    // If any document with the same sponsor_name exists, throw an error
    if (!querySnapshot.empty) {
      throw new Error(
        `A sponsor with the name "${data.sponsor_name}" already exists.`
      );
    }

    // Step 2: Proceed with image upload if the sponsor_name is unique
    if (data.payment_receipt) {
      const imageRef = ref(
        storage,
        `sponsor_receipts/${data.payment_receipt.name}`
      );
      const snapshot = await uploadBytes(imageRef, data.payment_receipt);

      if (!snapshot) {
        throw new Error("Failed to upload payment receipt.");
      }

      // Get the download URL of the uploaded image
      const downloadURL = await getDownloadURL(snapshot.ref);

      if (!downloadURL) {
        throw new Error(
          "Failed to retrieve download URL for the payment receipt."
        );
      }

      // Add the download URL to the sponsor data
      data.payment_receipt_url = downloadURL;

      // Remove the file object from the data to avoid storing it
      delete data.payment_receipt;
    }

    // Add the created_at timestamp
    data.created_at = `${new Date()}`;

    // Step 3: Save the sponsor data to Firestore
    await setDoc(doc(db, SPONSER_COLLECTION, data.sponsor_name), data);

    console.log("Sponsor data successfully added!");
  } catch (error) {
    console.error("Error adding sponsor data:", error);
    throw error; // Re-throw the error for the calling function to handle
  }
}

async function getAllSponsors() {
  try {
    // Reference to the SPONSER_COLLECTION in Firestore
    const sponsorCollectionRef = collection(db, SPONSER_COLLECTION);

    // Retrieve all documents from the collection
    const querySnapshot = await getDocs(sponsorCollectionRef);

    // Initialize an array to store sponsor data
    const sponsors = [];

    // Loop through each document in the snapshot and push the data to the array
    querySnapshot.forEach((doc) => {
      sponsors.push({ id: doc.id, ...doc.data() });
    });

    // Log or return the sponsors array
    console.log("Sponsors:", sponsors);
    return sponsors;
  } catch (error) {
    console.error("Error fetching sponsors:", error);
    throw error; // Throw the error so it can be handled in calling function
  }
}

async function searchData(key, value) {
  const queryData = query(
    collection(db, USER_COLLECTION),
    where(key, "==", value),
    where("type", "==", SCHOOL)
  );
  
  const querySnapshot = await getDocs(queryData);
  if (querySnapshot.docs.length > 0) {
    return querySnapshot.docs[0].data();
  } else {
    return null;
  }
}
async function searchDataCollege(key, value) {
  const queryData = query(
    collection(db, USER_COLLECTION),
    where(key, "==", value),
    where("type", "==", COLLEGE)
  );
  
  const querySnapshot = await getDocs(queryData);
  if (querySnapshot.docs.length > 0) {
    return querySnapshot.docs[0].data();
  } else {
    return null;
  }
}
async function findIsRegisteredAsSchool(email) {
  const queryData = query(
    collection(db, USER_COLLECTION),
    where("type", "==", SCHOOL),
    where("email", "==", email)
  );
  const querySnapshot = await getDocs(queryData);
  if (querySnapshot.docs.length > 0) {
    return true;
  } else {
    return false;
  }
}

async function findIsRegisteredAsCollege(email) {
  const queryData = query(
    collection(db, USER_COLLECTION),
    where("type", "==", COLLEGE),
    where("email", "==", email)
  );
  const querySnapshot = await getDocs(queryData);
  return querySnapshot.docs.length > 0;
}

async function getUserDetails(email) {
  const docRef = doc(db, USER_COLLECTION, email);
  const docSnap = await getDoc(docRef);

  if (docSnap.exists()) {
    return docSnap.data();
  } else {
    return null;
  }
}

async function getSponserDetails(id) {
  const docRef = doc(db, SPONSER_COLLECTION, id);
  const docSnap = await getDoc(docRef);

  if (docSnap.exists()) {
    return docSnap.data();
  } else {
    return null;
  }
}

async function signInUser(email, password) {
  try {
    const userCredential = await signInWithEmailAndPassword(
      auth,
      email,
      password
    );
    const user = userCredential.user;
    return user;
  } catch (error) {
    if (error.code == "auth/invalid-login-credentials") {
      window.alert(`Invalid credentials`);
    } else {
      window.alert(`Error while registering user.`);
    }
    console.log(error);
    return null;
  }
}
async function signUpUser(email, password) {
  try {
    const userCredential = await createUserWithEmailAndPassword(
      auth,
      email,
      password
    );
    const user = userCredential.user;
    return user;
  } catch (error) {
    console.log(error.code);
    if (error.code == "auth/email-already-in-use") {
      window.alert(`User is already registered with this email ID`);
    } else if (error.code == "auth/weak-password") {
      window.alert(
        `Password should be 8 character long including alphabets, numbers and symbols`
      );
    } else {
      window.alert(`Error while registering user.`);
    }
    return null;
  }
}
async function addAttendance(email, qrData) {
  const dateTime = new Date();
  const attendanceMap = {};
  const logData = {
    email: qrData.email,
    name: qrData.name,
    attendant_by: email,
    time: dateTime,
  };
  const yyyy = dateTime.getFullYear();
  let mm = dateTime.getMonth() + 1; // Months start at 0!
  let dd = dateTime.getDate();

  // if (dd < 10) dd = "0" + dd;
  // if (mm < 10) mm = "0" + mm;

  const formattedToday = dd + "/" + mm + "/" + yyyy;
  attendanceMap[formattedToday] = logData;
  try {
    await setDoc(doc(db, ATTENDANCE_COLLECTION, qrData.email), attendanceMap, {
      merge: true,
    });

    return 1;
  } catch (error) {
    console.log(error);
    return 0;
  }
}

async function addVisit(email, placeName) {
  const place = {
    name: placeName.name,
    lab_data: placeName.lab_data,
  };
  const logData = {
    email: email,
    presenter_email: placeName.email,
    place: place,
    time: new Date(),
  };
  try {
    const docRef = await addDoc(collection(db, VISIT_COLLECTION), logData);

    return docRef.id;
  } catch (error) {
    console.log(error);
    return null;
  }
}

async function sendResetPasswordLink(email) {
  await sendPasswordResetEmail(auth, email);
}

function getAllUsers(onData) {
  const q = query(collection(db, USER_COLLECTION), orderBy("name"));
  onSnapshot(
    q,
    (snapshot) => {
      const users = [];
      snapshot.docs.forEach((element) => {
        users.push(element.data());
      });
      onData(users);
    },
    (error) => {
      console.log(error);
    }
  );
}

function getAllVisits(onData) {
  const q = query(collection(db, VISIT_COLLECTION));
  onSnapshot(
    q,
    (snapshot) => {
      const users = [];
      snapshot.docs.forEach((element) => {
        users.push(element.data());
      });
      onData(users);
    },
    (error) => {
      console.log(error);
    }
  );
}

async function getAllUsersOneTime() {
  const users = [];
  const querySnapshot = await getDocs(collection(db, USER_COLLECTION));
  querySnapshot.forEach((doc) => {
    users.push(doc.data());
  });
  return users;
}
async function updateUser(data) {
  // console.log(data);
  await setDoc(doc(db, USER_COLLECTION, data.email), data);
}
async function updateSponserIndustry(data) {
  // console.log(data);
  await setDoc(doc(db, SPONSER_COLLECTION, data.sponsor_name), data);
}

function logoutUser() {
  return signOut(auth);
}

export {
  db,
  auth,
  // messaging,
  // requestPermission,
  // getFCMToken,
  findIsRegisteredAsCollege,
  addToken,
  addData,
  searchDataCollege,
  searchData,
  findIsRegisteredAsSchool,
  getUserDetails,
  signInUser,
  sendResetPasswordLink,
  signUpUser,
  addVisit,
  getAllUsers,
  logoutUser,
  updateUser,
  updateSponserIndustry,
  addAttendance,
  getAllUsersOneTime,
  getAllVisits,
  addSponserData,
  getAllSponsors,
  getSponserDetails,
};
